import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IamportalComponent } from './iamportal/iamportal.component';
import { AssignmentArenaComponent } from './assignment-arena/assignment-arena.component';
import { ManagementConfigurationComponent } from './management-configuration/management-configuration.component';
import { ProviderAvailabilityComponent } from './provider-availability/provider-availability.component';
import { AuthGuard } from './common/auth/auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [ AuthGuard ],
    children: [
      { path: '', component: IamportalComponent },
      {
        path: 'Management-Configuration',
        component: ManagementConfigurationComponent,
      },
      {
        path: 'Assignment-Arena',
        component: AssignmentArenaComponent,
      },
      {
        path: 'Provider-Availability',
        component: ProviderAvailabilityComponent,
      },
      {
        path: 'Iamportal',
        redirectTo: '',
      },
    ]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
